import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Hidden from "@material-ui/core/Hidden";
import Drawer, { DrawerProps } from "@material-ui/core/Drawer";
import clsx from "clsx";

export const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: drawerWidth,
  },
}));

export type ResponsiveDrawerProps = Omit<DrawerProps, "variant">;

function ResponsiveDrawer(props: ResponsiveDrawerProps) {
  const {
    className,
    classes: drawerClasses,
    ModalProps,
    ...drawerProps
  } = props;
  const classes = useStyles();

  const drawerClassesMemo = React.useMemo(() => {
    return {
      ...drawerClasses,
      paper: clsx(classes.drawerPaper, drawerClasses?.paper),
    };
  }, [classes.drawerPaper, drawerClasses]);

  const drawerClassNameMemo = React.useMemo(() => {
    return clsx(classes.root, className);
  }, [className, classes.root]);

  return (
    <>
      <Hidden xsDown>
        <Drawer
          className={drawerClassNameMemo}
          classes={drawerClassesMemo}
          variant="persistent"
          {...drawerProps}
        />
      </Hidden>
      <Hidden smUp>
        <Drawer
          className={drawerClassNameMemo}
          classes={drawerClassesMemo}
          variant="temporary"
          {...drawerProps}
          {...ModalProps}
        />
      </Hidden>
    </>
  );
}

export default ResponsiveDrawer;
